<script setup>
defineProps({
    isLoading: {
        type: Boolean,
        required: true,
    },
    hasResults: {
        type: Boolean,
        required: true,
    },
})
</script>

<template>
    <BaseContent class="layout-container">
        <div class="picker-header-container">
            <slot name="header"/>
        </div>
        <div>
            <div class="picker-container">
                <div>
                    <BaseSpinner
                        v-if="isLoading"
                        size="large"
                        class="loader"
                    />
                    <div
                        v-if="!isLoading && hasResults"
                        class="picker-items"
                    >
                        <slot name="picker"/>
                    </div>
                    <h5
                        v-if="!isLoading && !hasResults"
                        class="results-error"
                    >No results.</h5>
                </div>
            </div>
        </div>
        <div class="actions-container">
            <div
                padded
                class="actions-content"
            >
                <slot name="actions"/>
            </div>
        </div>
    </BaseContent>
</template>

<style lang="scss" scoped>
@use '@design' as *;
@use 'sass:color';

.layout-container {
    max-width: 100%;
}

.picker-container {
    padding-top: $s-m;
}

.picker-items {
    padding-bottom: $s-h * 5;
}

.results-error {
    text-align: center;
}

.actions-container {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    padding: $s-xl $s-xxl 0;
    // Background edge to edge, actions clear of the landscape notch (viewport-fit=cover).
    padding-right: calc(#{$s-xxl} + env(safe-area-inset-right));
    padding-left: calc(#{$s-xxl} + env(safe-area-inset-left));
    margin: 0 auto;
    background: $c-surface-scrim;
    border-top: 1px solid color.scale($c-text-tertiary, $alpha: -90%);

    .actions-content {
        margin: 0 auto;
    }
}
</style>
